import { render, staticRenderFns } from "./BlockRegions.vue?vue&type=template&id=acbc1934&scoped=true&"
import script from "./BlockRegions.vue?vue&type=script&lang=js&"
export * from "./BlockRegions.vue?vue&type=script&lang=js&"
import style0 from "./BlockRegions.vue?vue&type=style&index=0&id=acbc1934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbc1934",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VContainer,VRow,VSpacer})
